import { useContext } from "react";
import { ConfigContext } from "../App";

export function useCommonVars(userDetails) {
  const config = useContext(ConfigContext);
  const urls = config?.urls || {};

  const bank_name_sbp = config?.bank_name || "";
  const bankName = bank_name_sbp;

  return {
    percents: config?.referral_percents || [15, 5, 2.5],
    investPercent: config?.invest_percent ?? 0,
    minInvest: config?.min_invest ?? 0,
    minWithdraw: config?.min_withdraw ?? 0,
    maxInvest_s: config?.max_invest_s ?? 0,
    maxInvest_s_2: config?.max_invest_s_2 ?? null,
    cashbackPercent: config?.cashback_percent ?? 0,

    sbpCard: config?.sbp_card || "",
    bankCard: config?.bank_card || "",

    bankName,
    bank_name_sbp,
    bank_name_card: config?.bank_name_card || "",
    recipient_card: config?.recipient_card ?? "",
    recipient_SBP: config?.recipient_SBP || "",

    sbpCard2: config?.sbp_card2 || "",
    bankCard2: config?.bank_card2 || "",
    bankName2: config?.bank_name2 || "",
    bank_name_card2: config?.bank_name_card2 || "",
    recipient_card2: config?.recipient_card2 ?? "",
    recipient_SBP2: config?.recipient_SBP2 || "",
    
	PAYEER: config?.PAYEER || "",
	
    cryptoWallets: config?.crypto_wallets || {},
    channelId: config?.channel_id || "",
    channelUrl: urls.channel || "https://t.me/channel_username",
    chatUrl: urls.forum || "https://t.me/chat_username",
    supportUrl: urls.support || "https://t.me/support_username",
    botUsernameS: urls.botUsername || "",
    appUrl: urls.app || "",
    trainingUrl: urls.training || "",
    referralLink: `${urls.app || ""}?startapp=${userDetails?.referral_hash ?? ""}`,
  };
}



